import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  signal,
  ViewChild,
} from "@angular/core";
import * as download from "downloadjs";
import { FooterDataService } from "../../footer-data.service";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TestimonialService } from "../../services/testimonials/testimonials.service";
import { HamburgerStateService } from "../hamburger-state.service";
import { ReleaseNotesService } from "../../services/release-notes/release-notes.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: false,
})
export class FooterComponent implements OnInit {
  // Esc clears the visible keyboard-focus highlight from whichever footer control has it.
  
  @HostListener('keydown.escape')
  onEscape(): void {
    (document.activeElement as HTMLElement)?.blur();
  }

  private footerdataservice = inject(FooterDataService);
  private breakPointObserver = inject(BreakpointObserver);
  private destroyRef = inject(DestroyRef);
  private testimonialService = inject(TestimonialService);
  private hamburgerService = inject(HamburgerStateService);
  private releaseNotesService = inject(ReleaseNotesService);

  footerData = [
    {
      title: 'User Manual',
      items: this.hamburgerService.userManuals.map(manual => ({
        label: manual.name,
        url: manual.url,
        isDownload: manual.isdownload,
        isRoutable: manual.isRoutable,
      })),
    },
    ...this.footerdataservice.getfooterData().footerSections,
  ];
  isAccordionOpen = signal<boolean[]>([]);
  isMobile = signal<boolean>(false);
  visitorCount = signal<string>('--');
  visitorCountStartDate = new Date('2026-10-08');
  lastUpdatedOn: Date | null = new Date('2026-10-08');

  ngOnInit(): void {
    this.isAccordionOpen.set(this.footerData.map(() => false));
    this.getScreenSize();
    this.getVisitorCount();
    // this.getLastUpdatedOn();
  }

  getVisitorCount(): void {
    this.testimonialService.getVisitorCount().subscribe({
      next: (res) => {
        const count = res?.data?.total ?? res?.total ?? res;
        this.visitorCount.set(Number(count).toLocaleString('en-IN'));
      },
      error: () => {},
    });
  }

  getLastUpdatedOn(): void {
    this.releaseNotesService.getPublishedReleaseHistory({ page: 1, page_size: 1 }).subscribe({
      next: (res) => {
        const releaseDate = res?.data?.[0]?.release_date;
        if (releaseDate) {
          this.lastUpdatedOn = new Date(releaseDate);
        }
      },
      error: () => {},
    });
  }

  toggleAccordion(index: number): void {
    const current = this.isAccordionOpen();
    const updated = current.map((_, i) => i === index ? !current[i] : false);
    this.isAccordionOpen.set(updated);
  }
  

  downloadpdf(url: string): void {
    download(url);
  }

  getFileExtension(url: string): string {
    if (!url) return '';

    const cleanUrl = url.split(/[?#]/)[0];
    const fileName = cleanUrl.split('/').pop() || '';
    const extension = fileName.includes('.') ? fileName.split('.').pop() : '';

    return extension ? extension.toUpperCase() : '';
  }

  getScreenSize() {
    const max580$ = ["(max-width: 580px)"];
    this.breakPointObserver
      .observe(max580$)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((matches: BreakpointState) => {
        this.isMobile.set(matches.matches);
      });

  }
}
